import React, { useState } from "react";
import { Mail, ArrowRight, Check } from "lucide-react";
import { api } from "../lib/api";

/**
 * Compact newsletter opt-in for footer / anywhere.
 * POSTs to /api/newsletter/subscribe. Optimistic success UI.
 */
const NewsletterOptIn = ({ source = "footer" }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | loading | ok | error
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      setState("error");
      setMsg("Bitte gültige E-Mail eingeben.");
      return;
    }
    setState("loading");
    try {
      await api.post("/newsletter/subscribe", { email, source });
      setState("ok");
      setMsg("Du bist dabei! Wir melden uns bald mit Content-Insights.");
      setEmail("");
    } catch {
      setState("error");
      setMsg("Konnte nicht speichern. Bitte versuch es später erneut.");
    }
  };

  return (
    <div className="relative" data-testid="newsletter-optin">
      <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-neutral-500">
        Insider Newsletter
      </div>
      <h4 className="mt-3 font-display font-extrabold text-xl md:text-2xl text-white leading-[1.15] tracking-[-0.02em]">
        Content-Insights, Trends & Cases –{" "}
        <span className="bg-gradient-to-r from-pink-400 via-orange-400 to-purple-400 bg-clip-text text-transparent">
          direkt in dein Postfach.
        </span>
      </h4>
      <p className="mt-3 text-sm text-neutral-400 leading-relaxed">
        Kein Spam. Nur was funktioniert – aus echten Kampagnen.
      </p>

      <form onSubmit={submit} className="mt-5 flex flex-col sm:flex-row gap-2">
        <div className="flex-1 relative">
          <Mail
            size={14}
            className="absolute left-4 top-1/2 -translate-y-1/2 text-neutral-500"
          />
          <input
            type="email"
            required
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (state !== "idle") setState("idle");
            }}
            placeholder="deine@mail.de"
            className="w-full pl-10 pr-4 py-3.5 rounded-full bg-white/[0.04] border border-white/10 focus:border-pink-400/60 focus:bg-white/[0.06] outline-none text-sm text-white placeholder:text-neutral-500 transition-all"
            data-testid="newsletter-email-input"
          />
        </div>
        <button
          type="submit"
          disabled={state === "loading"}
          className="group inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-gradient-to-r from-pink-500 via-orange-500 to-purple-500 text-white text-xs font-bold tracking-[0.15em] uppercase hover:shadow-[0_18px_42px_-10px_rgba(236,72,153,0.6)] hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-60"
          data-testid="newsletter-submit-button"
        >
          {state === "loading" ? "…" : state === "ok" ? <Check size={14} /> : "Abonnieren"}
          {state !== "loading" && state !== "ok" && (
            <ArrowRight
              size={14}
              className="transition-transform duration-300 group-hover:translate-x-0.5"
            />
          )}
        </button>
      </form>

      {msg && (
        <div
          className={`mt-3 text-xs ${
            state === "ok" ? "text-emerald-400" : "text-red-400"
          }`}
          data-testid="newsletter-message"
        >
          {msg}
        </div>
      )}
    </div>
  );
};

export default NewsletterOptIn;
